import React, { useContext, useState, useEffect } from "react";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import { Link, useLocation } from "react-router-dom";
import Repo from "../../Utility/Repo";
import {
  Input,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "design-react-kit";
import ModalComponent from "../../Components/ModalComponent";
import Loader from "../../Components/Loader";
import { TokenContext } from "../../Components/TokenContext";
import ListIsee from "../../Components/ListIsee";
import ListUsers from "../../Components/ListUsers";
import Pagination from "../../Components/Pagination";
import UploadFile from "../../Components/UploadFile";
import moment from "moment";
import StateTranslate from "../../Components/StateTranslate";
import LabelsLoader from "../../Utility/labelsLoader";
import { AlertMessage, showError } from "../../Components/AlertMessage";
import BodyGenerateCsv from "../../Components/BodyGenerateCsv";
import DuplicateAnnouncementModal from "../../Components/DuplicateAnnouncementModal";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function AnnouncementDetail(props) {
  const apiToken = useContext(TokenContext);
  const d = moment();
  let query = useQuery();
  const [changeArray, setChangeArray] = useState(false);
  const [file, setFile] = useState();
  const [loading, setLoading] = useState(true);
  const [session, setSession] = useState({});
  const [sessionSubscription, setSessionSubscription] = useState({});
  const [sessionSubscriptionTemp, setSessionSubscriptionTemp] = useState();
  const [sessionSubscriptionTemp2, setSessionSubscriptionTemp2] = useState();
  const [service, setService] = useState({});
  const [id, setId] = useState();
  const [uploadCSV, setUploadCSV] = useState();
  const [errorImport, setErrorImport] = useState(false);
  const [isOpen, toggleModal] = useState(false);
  const [isOpenImport, toggleModalImport] = useState(false);
  const [isOpenCSVUpload, toggleModalCSVUpload] = useState(false);
  const [isOpenGenerateCSV, toggleModalGenerateCSV] = useState(false);
  const [isOpenReset, toggleReset] = useState(false);
  const [isOpenDuplicate, toggleModalDuplicate] = useState(false);
  const [duplicating, setDuplicating] = useState(false);

  const [isOpenRendicontazione, toggleModalRendicontazione] = useState(false);
  const [isOpenCSVDownload, toggleModalCSVDownload] = useState(false);
  const [showFileToggle, toggleModalShowFile] = useState(false);
  const [usersList, setUsersList] = useState([]);
  const [alertMessage, setAlertMessage] = useState("");
  const [subscribeError, setSubscribeError] = useState(false);
  const [alertShow, setAlertShow] = useState(false);
  const [uploadImport, setUploadImport] = useState();
  const [errorMessageImport, setErrorMessageImport] = useState(false);
  const [isUpdateIsees, setIsUpdateIsees] = useState(false);
  const [isRemoveOldSubscriptions, setIsRemoveOldSubscriptions] =
    useState(false);
  const [width, setWidth] = useState(window.innerWidth);

  const [apiError, setApiError] = useState({});
  const handleAlertClose = () => {
    setApiError({ isVisible: false, message: "" });
  };

  const [isOpenSubscribeUserOperator, toggleModalSubscribeUserOperator] =
    useState(false);

  const [sub, setSub] = useState({});

  const labels = LabelsLoader();

  const [sendImportCSV, setSendImportCSV] = useState({
    mese: "",
    anno: "",
  });

  const [filter, setFilter] = useState({
    firstName: "",
    lastName: "",
    fiscalCode: "",
    email: "",
    phoneNumber: "",
  });

const [filterSubscribed, setFilterSubscribed] = useState({
  search: "",
  iseeMin: "",
  iseeMax: "",
  state: "",
});
  const hub_url = process.env.REACT_APP_HUB_URL;

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Puoi impostare 'auto' per uno scorrimento immediato
    });
  };

  useEffect(() => {
    if (subscribeError) {
      const timer = setTimeout(() => {
        setSubscribeError(false);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [subscribeError]);

  useEffect(() => {
    if (alertShow) {
      const timer = setTimeout(() => {
        setAlertShow(false);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [alertShow]);

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);

  const apiGet = () => {
    if (apiToken) {
      setId(query.get("id"));
      if (query.get("id")) {
        setLoading(false);
        Repo.getSessionById(apiToken, query.get("id"))
          .then((response) => {
            if (response.status == 200) {
              setSession(response.data);
              console.log(response.data);

              const sortedSubscriptions = response.data.subscriptions.sort(
                (a, b) => a.user.lastName.localeCompare(b.user.lastName)
              );

              setSessionSubscriptionTemp(sortedSubscriptions);

              setLoading(true);
              Repo.getOneServices(apiToken, response.data.service.id)
                .then((response) => {
                  if (response.status == 200) {
                    setService(response.data);
                    setLoading(true);
                  }
                })
                .catch((error) => {
                  setLoading(true);
                  setApiError({ isVisible: true, message: showError(error) });
                });
            }
          })
          .catch((error) => {
            setLoading(true);
            setApiError({ isVisible: true, message: showError(error) });
          });
      } else {
      }
    }
  };

  useEffect(() => {
    apiGet();
  }, []);

  const duplicateSessione = (form, setError) => {
    if (!session?.id || duplicating) return;

    setDuplicating(true);
    Repo.duplicateSession(
      apiToken,
      JSON.stringify({
        announcementId: session.id,
        codAccertamento: form.codAccertamento,
        year: form.year,
      })
    )
      .then((response) => {
        if (response.status == 200) {
          const newId = response.data?.id || response.data?.Id;
          if (newId) {
            window.location.href =
              (props.subfolder || "") +
              "/lista_bandi/bando?id=" +
              newId;
            return;
          }
        }
        setDuplicating(false);
        if (setError) setError("Impossibile aprire il bando duplicato.");
      })
      .catch((error) => {
        setDuplicating(false);
        if (setError) setError(showError(error));
        else setApiError({ isVisible: true, message: showError(error) });
      });
  };

  const subscribeUser = (sub) => {
    let obj = {
      userId: sub.id,
      announcementId: session.id,
    };

    Repo.postSubscribeUserFromOperator(apiToken, JSON.stringify(obj))
      .then((response) => {
        if (response.status == 200) {
          window.location.reload();
          setSubscribeError(false);
        }
      })
      .catch((error) => {
        toggleModalSubscribeUserOperator(false);
        toggleModal(false);
        scrollToTop();
        setApiError({ isVisible: true, message: showError(error) });
      });
  };

  const sendFilter = () => {
    setLoading(false);
    Repo.getUsersList(apiToken, filter)
      .then((response) => {
        if (response.status == 200) {
          setUsersList(response.data);
          setLoading(true);
        }
      })
      .catch((error) => {
        setLoading(true);
        setApiError({ isVisible: true, message: showError(error) });
      });
  };

  const resetBando = () => {
    setLoading(false);
    Repo.getResetBando(apiToken, query.get("id"))
      .then((response) => {
        if (response.status == 200) {
          setLoading(true);
          toggleReset(false);
        }
      })
      .catch((error) => {
        setLoading(true);
        toggleReset(false);
        setApiError({ isVisible: true, message: showError(error) });
      });
  };

  const sendUrlPage = (url) => {
    var url2 = "";
    const location = window.location.href;
    if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
      // dev code
      console.log("dev code");
      let _url = props.subfolder + url;
      console.log(_url);
      url2 = props.subfolder + _url + "?urlBack=" + location;

      //process.env.PUBLIC_URL +
    } else {
      // production code
      console.log("production code");
      let _url = props.subfolder + url;

      url2 = _url + "?urlBack=" + location;
      console.log(url2);
    }
    const newTab = window.open(url2, "_blank");
    newTab.focus();
  };

  const downloadList = () => {
    setLoading(false);
    Repo.getListSubscription(apiToken, id)
      .then((response) => {
        if (response.status == 200) {
          const url = window.URL.createObjectURL(
            new Blob([response.data], { type: "text/csv" })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "listaUtenti_" + session.name + ".csv");
          document.body.appendChild(link);
          link.click();
          setLoading(true);
        }
      })
      .catch((error) => {
        setLoading(true);
        setApiError({ isVisible: true, message: showError(error) });
      });
  };

  const bodyImport = () => {
    return (
      <>
        <div className="row">
          <div className="form-check col-lg-6">
            <div className="toggles">
              <label htmlFor="toggleIsee">
                Vuoi aggiornare anche il valore isee?
                <input
                  onClick={() => setIsUpdateIsees(!isUpdateIsees)}
                  type="checkbox"
                  id="toggleIsee"
                />
                <span className="lever"></span>
              </label>
            </div>
          </div>
          <div className="form-check col-lg-6">
            <div className="toggles">
              <label htmlFor="toggleSub">
                Vuoi rimuovere le vecchie iscrizioni?
                <input
                  onClick={() =>
                    setIsRemoveOldSubscriptions(
                      (isRemoveOldSubscriptions) => !isRemoveOldSubscriptions
                    )
                  }
                  type="checkbox"
                  id="toggleSub"
                />
                <span className="lever"></span>
              </label>
            </div>
          </div>
        </div>
        <hr></hr>

        <UploadFile
          setErrorMessage={setErrorMessageImport}
          typeFile={["text/csv"]}
          handleFile={setUploadImport}
          testoCaricamento="File caricato correttamente"
          testoInterno="Seleziona file dal dispositivo"
          testoTitolo="Carica CSV"
        ></UploadFile>
        {errorMessageImport && (
          <div className="text-danger">
            Carica un file con un formato supportato
          </div>
        )}
        {!uploadImport && errorImport && (
          <div className="text-danger">Nessun file caricato</div>
        )}
      </>
    );
  };

  const uploadList = () => {
    let passedValidation = true;
    setErrorImport(true);
    setLoading(false);

    // Stesso CSV di "Lista utenti": Cognome;Nome;...;Ore settimanali;...;Data decesso
    const tempData = {
      fileContentBase64: "",
      contentType: "csv",
      updateIsees: isUpdateIsees,
      removeOldSubscriptions: isRemoveOldSubscriptions,
    };

    if (uploadImport) {
      var splitBase64 = uploadImport.split(",");
      tempData.fileContentBase64 = splitBase64[1];
    } else {
      passedValidation = false;
      setLoading(true);
    }

    if (passedValidation) {
      Repo.postCSVImport(apiToken, JSON.stringify(tempData), query.get("id"))
        .then((response) => {
          if (response.status === 200) {
            window.location.reload();
          }
        })
        .catch((error) => {
          toggleModalImport(false);
          window.scrollTo(0, 0);
          setApiError({ isVisible: true, message: showError(error) });
        })
        .finally(() => {
          setLoading(true);
        });
    }
  };

  const returnBodyModal = () => {
    return (
      <>
        <div className="row">
          <div className="col-lg-4">
            <Input
              id="first_name"
              required
              label="Nome"
              type="text"
              name="first_name"
              onChange={(e) =>
                setFilter({ ...filter, firstName: e.target.value })
              }
            />
          </div>
          <div className="col-lg-4">
            <Input
              id="last_name"
              required
              label="Cognome"
              type="text"
              name="last_name"
              onChange={(e) =>
                setFilter({ ...filter, lastName: e.target.value })
              }
            />
          </div>
          <div className="col-lg-4">
            <Input
              id="fiscal_code"
              required
              label="Codice Fiscale"
              type="text"
              name="fiscal_code"
              onChange={(e) =>
                setFilter({ ...filter, fiscalCode: e.target.value })
              }
            />
          </div>
        </div>

        <div className="row mt-2">
          <div className="col-lg-6">
            <Input
              id="email"
              required
              label="Email"
              type="text"
              name="email"
              onChange={(e) => setFilter({ ...filter, email: e.target.value })}
            />
          </div>
          <div className="col-lg-6">
            <Input
              id="phone_number"
              required
              label="Telefono"
              type="text"
              name="phone_number"
              onChange={(e) =>
                setFilter({ ...filter, phoneNumber: e.target.value })
              }
            />
          </div>
        </div>
        <div className="row mt-2 text-center">
          <div className="col-lg-12 clearfix">
            <button
              type="button"
              className="btn btn-outline-primary"
              onClick={sendFilter}
            >
              <span className="align-middle">Ricerca</span>
            </button>
          </div>
        </div>
        {usersList && usersList.length > 0 ? (
          <>
            <table className="table table-hover" style={{ cursor: "pointer" }}>
              <thead>
                <tr>
                  <th scope="col">Codice Fiscale</th>
                  <th scope="col">Nome</th>
                  <th scope="col">Cognome</th>
                  <th scope="col">Email</th>
                </tr>
              </thead>
              <tbody>
                {usersList.map((x, index) => (
                  <React.Fragment key={index}>
                    <tr
                      onClick={() => {
                        toggleModalSubscribeUserOperator(
                          !isOpenSubscribeUserOperator
                        );
                        setSub(x);
                      }}
                    >
                      <th scope="row">{x.fiscalCode}</th>
                      <td>{x.firstName}</td>
                      <td>{x.lastName}</td>
                      <td>{x.email}</td>
                    </tr>
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </>
        ) : (
          <>
            <span className="text">Nessun utente trovato</span>
            <div className="clear"></div>
            <a
              href="#"
              onClick={(e) => {
                sendUrlPage("/lista_utenti/nuovo_utente");
              }}
            >
              {" "}
              Nuovo utente
            </a>
          </>
        )}
      </>
    );
  };

useEffect(() => {
  let newArray = [];

  setChangeArray(false);

  if (sessionSubscriptionTemp !== undefined) {
    const search = (filterSubscribed.search || "").trim().toLowerCase();
    const iseeMin =
      filterSubscribed.iseeMin === "" || filterSubscribed.iseeMin == null
        ? null
        : parseFloat(filterSubscribed.iseeMin);
    const iseeMax =
      filterSubscribed.iseeMax === "" || filterSubscribed.iseeMax == null
        ? null
        : parseFloat(filterSubscribed.iseeMax);

    newArray = sessionSubscriptionTemp.filter((subscription) => {
      const user = subscription.user || {};
      const firstName = (user.firstName || "").toLowerCase();
      const lastName = (user.lastName || "").toLowerCase();
      const fiscalCode = (user.fiscalCode || "").toLowerCase();
      const fullName = `${lastName} ${firstName}`.trim();
      const fullNameRev = `${firstName} ${lastName}`.trim();

      const matchesSearch =
        !search ||
        firstName.includes(search) ||
        lastName.includes(search) ||
        fiscalCode.includes(search) ||
        fullName.includes(search) ||
        fullNameRev.includes(search);

      const iseeValue =
        user.isees?.[0]?.value != null && user.isees[0].value !== ""
          ? parseFloat(user.isees[0].value)
          : null;

      const matchesIseeMin =
        iseeMin == null ||
        Number.isNaN(iseeMin) ||
        (iseeValue != null && !Number.isNaN(iseeValue) && iseeValue >= iseeMin);

      const matchesIseeMax =
        iseeMax == null ||
        Number.isNaN(iseeMax) ||
        (iseeValue != null && !Number.isNaN(iseeValue) && iseeValue <= iseeMax);

      const matchesState =
        !filterSubscribed.state || subscription.state === filterSubscribed.state;

      return matchesSearch && matchesIseeMin && matchesIseeMax && matchesState;
    });

    setSessionSubscriptionTemp2(newArray);
    setChangeArray(true);
  }
}, [filterSubscribed, sessionSubscriptionTemp]);

  const bodyFile = () => {
    return (
      <object
        width="100%"
        height="900"
        data={file && file.data}
        type={file && file.type}
      ></object>
    );
  };

  const bodyReset = () => {
    return (
      <p>
        Cliccando su "Conferma", verranno resettate tutte le assegnazioni per
        gli utenti in stato ACCETTATO
      </p>
    );
  };

  const showFile = (id) => {
    setLoading(true); // Imposta l'indicatore di caricamento a true prima di avviare la richiesta

    Repo.downloadFileOperator(apiToken, id)
      .then((response) => {
        if (response.status === 200) {
          setFile();
          var obj = document.createElement("object");
          obj.type = "application/pdf";
          obj.data = "data:application/pdf;base64," + response.data;
          setFile(obj);

          toggleModalShowFile(!showFileToggle);
        }
      })
      .catch((error) => {
        setApiError({ isVisible: true, message: showError(error) });
      })
      .finally(() => {
        setLoading(false); // Rimuovi l'indicatore di caricamento sia in caso di successo che in caso di errore
      });
  };

  const generateCSV = () => {
    setLoading(false);
    Repo.generateCsv(apiToken, id, sendImportCSV)
      .then((response) => {
        if (response.status == 200) {
          const url = window.URL.createObjectURL(
            new Blob([response.data], { type: "text/csv" })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "CSV " + session.name + ".csv");
          document.body.appendChild(link);
          link.click();
          setLoading(true);
          toggleModalGenerateCSV(!isOpenGenerateCSV);
        }
      })
      .catch((error) => {
        setLoading(false);
        setApiError({ isVisible: true, message: showError(error) });
        toggleModalGenerateCSV(!isOpenGenerateCSV);
      });
  };

  const sendMyPay = () => {
    setLoading(false);
    Repo.sendMyPay(apiToken, id, sendImportCSV, null)
      .then((response) => {
        if (response.status === 200) {
          setLoading(true);
          toggleModalCSVUpload(!isOpenCSVUpload);
          setAlertShow(true);
          setAlertMessage("Flusso inviato correttamente a MyPay");
        }
      })
      .catch((error) => {
        setLoading(true);

        setApiError({ isVisible: true, message: showError(error) });
        toggleModalCSVUpload(!isOpenCSVUpload);
      });
  };

  const sendRendicontazione = () => {
    setLoading(false);
    Repo.getRendicontazione(apiToken, id)
      .then((response) => {
        if (response.status == 200) {
          setLoading(true);
          toggleModalRendicontazione(!isOpenRendicontazione);
          setAlertShow(true);
          setAlertMessage("La rendicontazione è in corso");
        }
      })
      .catch((error) => {
        setLoading(true);
        setApiError({ isVisible: true, message: showError(error) });
        toggleModalRendicontazione(!isOpenRendicontazione);
      });
  };

  const fileListDownload = () => {
    return (
      <>
        {session.announcementFiles && session.announcementFiles.length > 0 && (
          <h4 className="mt-4">Modulista caricata</h4>
        )}
        <div className="row mt-4">
          {session.announcementFiles &&
            session.announcementFiles.length > 0 &&
            session.announcementFiles.map((x, index) => (
              <React.Fragment key={x.storageFileId}>
                <div className="col-2">
                  <button
                    className="btn btn-lg"
                    onClick={() => showFile(x.storageFileId)}
                    title={x.description}
                  >
                    <svg className="icon icon-primary">
                      <use href={`${iconSprite}#it-file`} />
                    </svg>{" "}
                    {x.name}
                  </button>
                </div>
              </React.Fragment>
            ))}
        </div>
      </>
    );
  };

  return (
    <>
      <h1 className={session?.state === "ARCHIVED" ? "text-muted" : undefined}>
        {session.name}
      </h1>

      <div className="clearfix col-lg-8 py-lg-2">
        <p>
          <StateTranslate text={session.state} trasform="U" />
        </p>
      </div>
      {apiError.isVisible && (
        <AlertMessage
          isVisible={apiError.isVisible}
          onClose={handleAlertClose}
          error={apiError.message}
        />
      )}
      <div className="row">
        <div className="col-lg-12 text-right">
          <button
            type="button"
            className="btn btn-outline-primary mr-2"
            onClick={() => toggleModalDuplicate(true)}
          >
            <svg className="icon icon-primary">
              <use href={`${iconSprite}#it-files`} />
            </svg>{" "}
            <span className="align-middle">Duplica bando</span>
          </button>
          <button
            type="button"
            className="btn btn-outline-primary"
            onClick={() =>
              (window.location.href =
                props.subfolder +
                "/lista_bandi/bando/modifica_sessione?sessionId=" +
                session.id)
            }
          >
            <span className="align-middle">Modifica bando</span>
          </button>
        </div>
      </div>

      <hr />

      {session ? (
        <>
          <div className="row mt-3">
            <div className="col-lg-4">
              Titolo:{" "}
              <span className="text">
                <b>{session.name}</b>
              </span>
            </div>
            {service && (
              <>
                <div className="col-lg-4">
                  Servizio:{" "}
                  <span className="text">
                    <b>{service.name} </b>
                  </span>
                </div>
              </>
            )}
            <div className="col-lg-2">
              Stato:{" "}
              <span className="text">
                <b>
                  <StateTranslate text={session.state} trasform="U" />
                </b>
              </span>
            </div>
            <div className="col-lg-2">
              Anno:{" "}
              <span className="text">
                <b>{session.year && session.year}</b>
              </span>
            </div>
          </div>

          <hr className="pb-4 " />
          <div className="row ">
            <div className="col-lg-6">
              Nome My Pay:{" "}
              <span className="text">
                <b>{session.nomeMyPay && session.nomeMyPay}</b>
              </span>
            </div>
            <div className="col-lg-3">
              Codice Accertamento:{" "}
              <span className="text">
                <b>{session.codAccertamento && session.codAccertamento}</b>
              </span>
            </div>
            <div className="col-lg-3">
              Codice Capitolo:{" "}
              <span className="text">
                <b>{session.codCapitolo && session.codCapitolo} </b>
              </span>
            </div>
          </div>
          <hr className="pb-4" />

          {fileListDownload()}

          <div
            className="d-flex flex-wrap align-items-center justify-content-end mb-4"
            style={{ gap: "0.75rem" }}
          >
            {session?.state !== "ARCHIVED" && (
              <>
                <button
                  type="button"
                  className="btn btn-outline-primary p-2"
                  onClick={() => {
                    toggleModalGenerateCSV(!isOpenGenerateCSV);
                  }}
                >
                  <svg className="icon icon-primary">
                    <use href={`${iconSprite}#it-settings`} />
                  </svg>{" "}
                  <span className="align-middle">{labels.verificaCsv}</span>
                </button>
                <button
                  type="button"
                  className="btn btn-outline-primary p-2"
                  onClick={() => {
                    toggleModalCSVUpload(!isOpenCSVUpload);
                  }}
                >
                  <svg className="icon icon-primary">
                    <use href={`${iconSprite}#it-upload`} />
                  </svg>{" "}
                  <span className="align-middle">{labels.inviaCsv}</span>
                </button>
              </>
            )}
            <Link
              to={`/ore_fatturate?id=${query.get("id") || ""}`}
              className="btn btn-outline-primary p-2"
            >
              <svg className="icon icon-primary">
                <use href={`${iconSprite}#it-calendar`} />
              </svg>{" "}
              <span className="align-middle">Ore fatturate</span>
            </Link>
            <button
              type="button"
              className="btn btn-outline-success text-success p-2"
              onClick={() => {
                toggleModalRendicontazione(!isOpenRendicontazione);
              }}
            >
              <svg className="icon icon-success">
                <use href={`${iconSprite}#it-download`} />
              </svg>{" "}
              <span className="align-middle">{labels.rendicontazione}</span>
            </button>
          </div>

          <ListIsee bands={session.bands}></ListIsee>
        </>
      ) : (
        <>
          <span className="text">Il bando selezionato non è presente.</span>
        </>
      )}

      <ListUsers
        toggleModalImport={toggleModalImport}
        isOpenImport={isOpenImport}
        downloadList={downloadList}
        setFilterSubscribed={setFilterSubscribed}
        filterSubscribed={filterSubscribed}
        sessionSubscriptionTemp={sessionSubscriptionTemp}
        sessionSubscriptionTemp2={sessionSubscriptionTemp2}
        setSessionSubscriptionTemp={setSessionSubscriptionTemp}
        setSessionSubscriptionTemp2={setSessionSubscriptionTemp2}
        session={session}
        sessionSubscription={sessionSubscription}
        setSessionSubscription={setSessionSubscription}
        changeArray={changeArray}
        toggleModal={toggleModal}
        toggleReset={toggleReset}
        isOpenReset={isOpenReset}
        isOpen={isOpen}
        apiGet={apiGet}
        setSub={setSub}
        sub={sub}
      ></ListUsers>

      {/* Modali */}
      <Modal
        isOpen={isOpen}
        toggle={() => toggleModal(!isOpen)}
        size={"lg"}
        labelledBy="Modale1"
        className="modalFit"
        style={{ top: "20%" }}
      >
        <ModalHeader id="Modale1">Iscrivi Utente</ModalHeader>
        <ModalBody>{returnBodyModal()}</ModalBody>
        <ModalFooter>
          <Button
            color="info text-white"
            onClick={() => {
              toggleModal(!isOpen);
              setUsersList([]);
            }}
          >
            Indietro
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        isOpen={isOpenSubscribeUserOperator}
        toggle={() =>
          toggleModalSubscribeUserOperator(!isOpenSubscribeUserOperator)
        }
        size={"lg"}
        labelledBy="Modale1"
        className="modalFit"
        style={{ top: "20%" }}
      >
        <ModalHeader id="Modale1">Iscrivi Utente</ModalHeader>
        <ModalBody>
          <div className="row p-2">
            <p>Sei sicuro di voler iscrivere l'utente al bando ?</p>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary text-white text-center"
            onClick={() => subscribeUser(sub)}
          >
            Conferma
          </Button>
          <Button
            color="info text-white text-center"
            onClick={() => {
              toggleModalSubscribeUserOperator(!isOpenSubscribeUserOperator);
            }}
          >
            Indietro
          </Button>
        </ModalFooter>
      </Modal>

      <ModalComponent
        toggleModal={toggleModalCSVUpload}
        isOpen={isOpenCSVUpload}
        header={labels.inviaCsv}
        body={
          <BodyGenerateCsv
            sendImportCSV={sendImportCSV}
            setSendImportCSV={setSendImportCSV}
          />
        }
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => sendMyPay()}
      ></ModalComponent>

      <ModalComponent
        toggleModal={toggleModalCSVUpload}
        isOpen={isOpenCSVUpload}
        header={labels.inviaCsv}
        body={
          <BodyGenerateCsv
            sendImportCSV={sendImportCSV}
            setSendImportCSV={setSendImportCSV}
          />
        }
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => sendMyPay()}
      ></ModalComponent>

      <ModalComponent
        toggleModal={toggleModalGenerateCSV}
        isOpen={isOpenGenerateCSV}
        header="Genera CSV"
        body={
          <BodyGenerateCsv
            sendImportCSV={sendImportCSV}
            setSendImportCSV={setSendImportCSV}
          />
        }
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => generateCSV()}
      ></ModalComponent>

      <ModalComponent
        toggleModal={() => toggleModalShowFile(!showFileToggle)}
        isOpen={showFileToggle}
        header={"File"}
        body={bodyFile()}
        buttonDeny="Chiudi"
      ></ModalComponent>

      <ModalComponent
        toggleModal={toggleModalRendicontazione}
        isOpen={isOpenRendicontazione}
        header="Rendicontazione"
        body="Saranno associati i pagamenti agli utenti iscritti e potrai visualizzare lo stato dei pagamenti"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => sendRendicontazione()}
      ></ModalComponent>

      <ModalComponent
        toggleModal={toggleModalImport}
        isOpen={isOpenImport}
        header="Import dati utenti"
        body={bodyImport()}
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => uploadList()}
      ></ModalComponent>

      <ModalComponent
        toggleModal={toggleReset}
        isOpen={isOpenReset}
        header="Resetta iscrizioni utenti"
        body={bodyReset()}
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => resetBando()}
      ></ModalComponent>

      <DuplicateAnnouncementModal
        isOpen={isOpenDuplicate}
        toggleModal={toggleModalDuplicate}
        onConfirm={duplicateSessione}
        loading={duplicating}
      />

      {subscribeError && (
        <div
          className="alert alert-danger"
          role="alert"
          style={{
            position: "fixed",
            backgroundColor: "white",
            bottom: "0px",
            right: "5px",
            zIndex: "10000",
          }}
        >
          {alertMessage}
        </div>
      )}

      {alertShow && (
        <div
          className="alert alert-success"
          role="alert"
          style={{
            position: "fixed",
            backgroundColor: "white",
            bottom: "0px",
            right: "5px",
            zIndex: "10000",
          }}
        >
          {alertMessage}
        </div>
      )}
      {!loading && <Loader></Loader>}
    </>
  );
}

export default AnnouncementDetail;
